export default "__VITE_ASSET__D9m2yqVL__"